import $ from "jquery";

/* Fnac Framework*/
/**************** EXEMPLE **************** /
AppCore.ready(function(){
AppCore.register('testmodule', function(){
//Private elements
var private_var = 17;
function private_function()
{
return private_var;
}
//Public elements
return {
public_var: 0,
init: function()
{
this.public_var = private_function();
},
destroy: function()
{

},
public_function: function()
{
alert("Hello je suis public"+this.public_var);
}
}
});
//Launching init module function
AppCore.start('testmodule');
AppCore.modules.testmodule.public_function();
//Trying to register existing modules -> throw error.
AppCore.register('testmodule', function(){});
});
/***************************************** /
Waiting for the named module to be ready.
AppCore.modules.ready('nomDuModule', function(){

});*/
//Checking Base Component(actually JQuery)
        var modules = {
            stackCallbacks: {},
            ready: function(moduleName, callback)
            {
                if(this[moduleName] && this[moduleName]["isready"] == true)
                {
                    this[moduleName]["callbackFunction"] = callback;
                    this[moduleName]["callbackFunction"]();
                    delete this[moduleName]["callbackFunction"];
                    //callback();
                }
                else
                {
                    this.stackCallbacks[moduleName] ? this.stackCallbacks[moduleName].push(callback) : this.stackCallbacks[moduleName] = [callback];
                }
            }
        };
        function setModulesInheritParams(module)
        {
            module["isready"] = true;
            module["Me"] = module;
            module["parent"] = AppCore;
            module["core"] = AppCore;
        }
        function fireModuleReady(moduleName)
        {
            if(modules.stackCallbacks[moduleName])
            {
                var len = modules.stackCallbacks[moduleName].length;
                for(var i = 0;i < len;i++)
                {
                    modules.stackCallbacks[moduleName][i]();
                }
            }
        };
        //Registering Module
        const AppCore = {
            modules: modules,
            /** @param moduleName : namespace of module
            @param moduleContent : object containing properties, functions of the module */
            register: function(moduleName, moduleContent)
            {
                var rReturn = false;
                if(!modules[moduleName])
                {
                    modules[moduleName] = moduleContent();
                    setModulesInheritParams(modules[moduleName]);
                    fireModuleReady(moduleName);
                    rReturn = true;
                }
                return rReturn;
            },
            start: function(moduleName, args)
            {
                var rReturn = null;
                if(modules[moduleName])
                {
                    modules[moduleName].init(args);
                    rReturn = modules[moduleName];
                }
                else
                {
                    modules.ready(moduleName, function() { modules[moduleName].init(args); });
                }
                //else throw new Error("Module "+moduleName+" not registered");

                return rReturn;
            },
            //Embed your code in ready function only if you need to use JQuery in init process.
            ready: function(handler)
            {
                $(document).ready(handler);
            },
            //Add function
            extend: function(extendName, functionToAdd)
            {
                if(!this[extendName])
                {
                    this[extendName] = functionToAdd;
                }
                else
                {
                    //throw new Error("AppCore : Extension " + extendName + " is existing");
                }
            }
        };

AppCore.register("popins", function()
{
    var params = {
        //Id given to the popin container created
        idPopinContainer: "popin_container",
        //Classes added at the popin container
        classes: [],
        //z-index de la popin
        zIndex: 10001,
        //Offset of position
        offset: { left: 0, top: 0 },
        //Content of the popin - string or jquery object
        content: "",
        //Time in milliseconds of opening fader
        openFader: 0,
        //Time in milliseconds of closing fader
        closeFader: 0,
        //Reference object of where to place the popin
        positionReferer: null,
        //Time before automatically close the popin. In milliseconds
        closeTimer: null,
        //Offset popin left position if too large.
        manageLeftOverride: true,
        //Layer object : hasLay : bool. If layer is an html object, give to layerObject property the jquery object reference.
        //cssLayer : css object set to the layer ex : {"background-color": "black"}
        layer: { hasLayer: false, layerObject: null, cssLayer: null },
        //If popin closing on pressing escape key.
        closeOnEscapeKey: true,
        //If popin closing on clicking on layer.
        closeOnClickLayer: true
    };
    var listCurrentPopins = {};
    function getPositionPopin(args, popin)
    {
        var pos = { top: 0, left: 0 };
        if(args.positionReferer != null)
        {
            pos = args.positionReferer.offset();
        }
        else
        {
            //Centering popin
            pos.left = ($(window).width() - popin.width()) / 2;
            pos.top = (($(window).height() - popin.height()) / 2) + popin.offset().top;
        }
        //Adding offset
        pos.top += args.offset.top;
        pos.left += args.offset.left;
        if(args.manageLeftOverride)
        {
            var overflow = $(window).width() - (popin.width() + pos.left);
            if(overflow < 0)
            {
                pos.left += overflow;
            }
        }
        return pos;
    }
    function showPopin(args)
    {
        if(!$("#" + args.idPopinContainer).length) //TODO RSA : pb ajax "this" object.
        {
            var append = "<div id='" + args.idPopinContainer + "' style='position:absolute;display:none;' class='" + (args.classes.join(" ")) + "'></div>";
            $("body").append(append);
        }
        var popin = $("#" + args.idPopinContainer);
        if(args.content["detach"])
        {
            args.content.show().detach();
        }
        popin.html(args.content);
        var pos = getPositionPopin(args, popin);
        popin.css({
            top: pos.top + "px",
            left: pos.left + "px",
            "z-index": args.zIndex
        });
        var layer = null;
        if(args.layer.hasLayer)
        {
            if(args.layer.layerObject != null)
            {
                layer = args.layer.layerObject;
                layer.detach();
                $("body").append(layer);
                layer.css("position", "fixed");
            }
            else
            {
                $("body").append("<div id='" + args.idPopinContainer + "_layer' style='position:fixed'></div>");
                layer = $("#" + args.idPopinContainer + "_layer");
                if(args.layer.cssLayer) layer.css(args.layer.cssLayer);
            }
            layer.css({
                height: "100%",
                width: "100%",
                top: 0,
                left: 0,
                "z-index": args.zIndex - 1
            });
            layer.fadeTo(args.openFader, layer.css('opacity'));
            //layer.fadeIn(args.openFader);
            if(args.closeOnClickLayer)
            {
                layer.off("click").click(function(e)
                {
                    e.preventDefault();
                    hidePopin(popin, layer, args.closeFader);
                    return false;
                });
            }
        }
        popin.fadeIn(args.openFader);
        listCurrentPopins[args.idPopinContainer] = args;
        if(args.closeTimer != null)
        {
            setTimeout(function() { hidePopin(popin, layer, args.closeFader); }, args.closeTimer);
        }
        //If escape key defined -> listen keypress event.
        if(args.closeOnEscapeKey)
        {
            $(document).off("keypress").keypress(function(key)
            {
                if(key.keyCode == 27/*Escape*/)
                {
                    hidePopin(popin, layer, args.closeFader);
                }
            });
        }
        //If close button -> listen click event on this close button.
        if(args.closeButton != null)
        {
            args.closeButton.off("click").on("click", function(e)
            {
                e.preventDefault();
                hidePopin(popin, layer, args.closeFader);
                return false;
            });
        }
        return popin;
    }
    function hidePopin(popinContainer, layer, closeFader)
    {
        popinContainer.fadeOut(closeFader);
        popinContainer.children().fadeOut(closeFader);
        if(layer != null && typeof layer != "undefined")
        {
            layer.fadeOut(closeFader);
        }
        //delete listCurrentPopins[popinContainer.attr("id")];
    }
    function initArgs(args)
    {
        var prop;
        for(prop in params)
        {
            //If no property overriden in showPopin use default
            if(!args[prop])
            {
                args[prop] = params[prop];
            }
        }
        return args;
    }
    return {
        /**
        * @params
        **/
        showPopin: function(args)
        {
            var args = initArgs(args);
            return showPopin(args);
        },
        closePopin: function(popin)
        {
            if(popin)
            {
                var args = listCurrentPopins[popin.attr("id")];
                if(args)
                {
                    var layer = null;
                    if(args.layer.hasLayer)
                    {
                        layer = args.layer.layerObject != null ? args.layer.layerObject : $("#" + args.idPopinContainer + "_layer");
                    }
                    hidePopin(popin, layer, args.closeFader);
                }
            }
        }
    };
});

export default AppCore;
// Tmp fix
window.AppCore = AppCore;
